import { useAtom } from 'jotai';
import { Button, Indicator } from '@optiaxiom/react';
import { IconBell } from '@optimizely/axiom-icons';

import { activeRightSidebarAtom } from '@frontend/atoms';
import {
  useBadgeCount,
  useNotificationFeatures,
  useUnreadCount,
} from '@frontend/features/notifications/hooks';
import { formatUnreadCount } from '@frontend/features/notifications/utils';

export function NotificationBellButton() {
  const [activeRightSidebar, setActiveRightSidebar] = useAtom(activeRightSidebarAtom);
  const { badgeEnabled, groupingEnabled } = useNotificationFeatures();

  const { data: badgeCount } = useBadgeCount({ enabled: badgeEnabled, grouped: groupingEnabled });
  const { data: unreadCount } = useUnreadCount({
    enabled: !badgeEnabled,
    grouped: groupingEnabled,
  });

  const badgeContent = formatUnreadCount(badgeEnabled ? badgeCount : unreadCount);

  return (
    <Button
      appearance="subtle"
      aria-label="Notifications"
      icon={
        <Indicator content={badgeContent} disabled={!badgeContent} intent="danger" variant="strong">
          <IconBell />
        </Indicator>
      }
      onClick={() =>
        setActiveRightSidebar(activeRightSidebar === 'notifications' ? null : 'notifications')
      }
      size="lg"
      square
    />
  );
}
